import { Divider, Grid, Typography } from '@mui/material'
import AdminMenuTitle from 'components/AdminMenuTitle/AdminMenuTitle'
import { useTranslation } from 'react-i18next'
import SystemUOMLookupTable from './components/UOMLookupTables/SystemUOMLookupTable'
import CustomUOMLookupTable from './components/UOMLookupTables/CustomUOMLookupTable'

function UOMsLookup() {
    const { t } = useTranslation()
    return (
        <Grid container spacing={2}>
            <Grid item sx={{ display: { sm: 'block', xs: 'none' } }} xs={12}>
                <AdminMenuTitle title={t('uoms.title.uoms')} />
            </Grid>

            <Grid item container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {t('uoms.title.custom_uoms')}
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <CustomUOMLookupTable />
                </Grid>
            </Grid>
            <Grid item xs={12}>
                <Divider sx={{ width: '100%' }} />
            </Grid>

            <Grid item container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="h6">
                        {t('uoms.title.system_uoms')}
                    </Typography>
                </Grid>

                <Grid item xs={12}>
                    <SystemUOMLookupTable />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default UOMsLookup
